import React from 'react'
import Link from 'gatsby-link'
import { Container, Row, Col } from 'reactstrap';

const SpecialH1 = ({title}) => (
  <h1 style={{ margin: 0 }}>
    <Link
      to="/"
      style={{
        color: 'white',
        textDecoration: 'none',
      }}
    >
      {title}
    </Link>
  </h1>
)

const SpecialH4 = ({title, link}) => (
  <h4 style={{ margin: 0 }}>
    <Link
      to={`/`+link}
      style={{
        color: 'white',
        textDecoration: 'none',
      }}
    >
      {title}
    </Link>
  </h4>
)

const Header = ({ siteTitle }) => (
  <div
    style={{
      background: 'darkblue',
      marginBottom: '1.45rem',
    }}
  >
    <div className="grid-container">
      <div className="item1"></div>
      <div>
      <SpecialH1 title="Andrew Takao" link = ""/>
      </div>
      <div></div>
      <div></div>
      <div></div>
      <div>
      <SpecialH4 title="About Me" link = ""/>
      </div>
      <div>
      <SpecialH4 title="Funny" link="funny-page"/>
      </div>
      <div>
      <SpecialH4 title="Empty" link = ""/>
      </div>
    </div>
  </div>
)

export default Header



// WEBPACK FOOTER //
// ./src/components/header.js